import { hotlineProFirstReplyText } from '@/feature/hotline/professional/firstReply/constant/text';
import { t } from '@/utils/constants/text/text';
import { z } from '@/utils/libs/zod/base';
const messages = t.validation;
const { label } = hotlineProFirstReplyText;
/**
 * 匿名コンサルホットライン 初回返信 schema
 */
export const hotlineProFirstReplyFormSchema = z.object({
    /**
     * アドバイスに活かせる経験・実績
     */
    agenda: z
        .string({ required_error: messages.required(label.agenda()) })
        .min(1, messages.required(label.agenda()))
        .max(10000, messages.maxLength(10000, label.agenda())),
    /**
     * その他の事前確認事項
     */
    description: z
        .string({ required_error: messages.required(label.description()) })
        .min(1, messages.required(label.description()))
        .max(10000, messages.maxLength(10000, label.description())),
    /**
     * その他のメッセージ
     */
    other: z
        .string()
        .max(10000, messages.maxLength(10000, label.other()))
        .or(z.literal(''))
        .optional(),
    /**
     * 相談時にアドバイスできること
     */
    similarProject: z
        .string({ required_error: messages.required(label.similarProject()) })
        .min(1, messages.required(label.similarProject()))
        .max(10000, messages.maxLength(10000, label.similarProject())),
});
